export const FETCH_ALL_CALL_HISTORIES = "FETCH_ALL_CALL_HISTORIES";
export const FETCH_ALL_CALL_HISTORIES_SUCCESS =
  "FETCH_ALL_CALL_HISTORIES_SUCCESS";
export const FETCH_ALL_CALL_HISTORIES_ERROR = "FETCH_ALL_CALL_HISTORIES_ERROR";
